import { Injectable } from "@angular/core";
import { AddedToCartDialogEventListener } from "@spartacus/cart/base/components";
import { CartUiEventAddToCart } from "@spartacus/cart/base/root";
import { take } from "rxjs";

@Injectable({
    providedIn: 'root',
})
export class UDXAddedToCartDialogEventListener extends AddedToCartDialogEventListener {
    override openModal(event: UDXCartUiEventAddToCart): void {
        // Raj: Overriding behavior to use custom dialog
        if (event.filteredEntries && event.filteredEntries.length > 0) {
        const addToCartData = {
            productCode: event.productCode,
            quantity: event.quantity,
            numberOfEntriesBeforeAdd: event.numberOfEntriesBeforeAdd,
            pickupStoreName: event.pickupStoreName,
            orderEntriesArray: event.orderEntriesArray,
            filteredEntries : event.filteredEntries
          };
      
          // Raj: USJCOMM-6370: If the product contains variants it means it is of type base variant and sub variants: Studio passes for example
            const dialog = this.launchDialogService.openDialog(
              "UDX_ADDED_TO_CART",
              undefined,
              undefined,
              addToCartData
            );  
            if (dialog) {
              dialog.pipe(take(1)).subscribe();
            }   
          }
    }
}

export class UDXCartUiEventAddToCart extends CartUiEventAddToCart {
  /**
   * Event's type
   */
  containsVariants?: boolean;
  orderEntriesArray?: any[];
  filteredEntries?: any[] ;
}
